import type { FaireProductEntity } from "../../entity_types/product";

export const viverano_16: FaireProductEntity = {
  token: "viverano-16",
  type: "product",
  name: "Oat Heather - Stripe Hooded Baby Knit Pullover (Organic)",
  brandName: "Viverano Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/1e836d88a12c1f685f72ea7cd29ed7c96962cf1107f2bfcae1041a5955ce75ed.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&precrop=2427,2427,x32,y52,safe&width=720",
  priceDollars: 24.5,
  msrpDollars: 42,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_apparel-baby"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
